export default __webpack_public_path__ + "static/media/commentsIcon.53289970.svg";